import { Integration } from "../types";
import { AlertClientResponse } from "./types";

export abstract class TelemetryClient {
    constructor(protected integration: Integration) {}

    abstract getAlerts(): Promise<AlertClientResponse[]>;
}